import { Filter } from '../filter';
import { ErrorType, FieldValues } from '../types';

export class EqualFilter<OutputType> implements Filter<OutputType> {
    constructor(public expectedValue: OutputType) {}

    async validate(fieldValue: OutputType, otherFields: FieldValues): Promise<Array<ErrorType>> {
        if (fieldValue !== this.expectedValue) {
            return [{ code: 'equal', expectedValue: this.expectedValue }];
        }
        return [];
    }
}
